import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NewsLetter from '../components/NewsLetter';
import LanguageConfig from '../config/supported_languages';

class Contact extends Component {
    constructor(props) {
        super(props)
    }
    toogle_drop_language(state) {
        if('none' == getComputedStyle(this.dropdown_language).display) {
            this.dropdown_language.style.display = 'block';
        } else {
            this.dropdown_language.style.display = 'none';
        }
    }

    generate_lang_active(code) {
        let style = {}
        if(code === this.props.lang) {
            style = Object.assign(style, {
                backgroundColor: '#FFF'
            })
        }
        return style;
    }
    render() {
        const { lang, trans } = this.props;
        const code = (lang != "" ? ("/" + lang) : "");
        return (
            <div>
                <div className="subpage-header contact-1">
                    <div data-collapse="medium" data-animation="default" data-duration="400" className="navbar with-color-button w-nav">
                        <div className="w-container">
                            <div className={"btn-group dropright drop-menu "}>
                                <button type="button"
                                    onClick={this.toogle_drop_language.bind(this)}
                                    className="dropdown-toggle drop-content"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">{trans('language')}</button>
                                <div className="dropdown-menu" id="dropdown-menu" ref={inst => this.dropdown_language = inst}>
                                    {LanguageConfig.list.map(item =>
                                        <Link key={"lang__" + item.code} style={this.generate_lang_active(item.code)} to={item.code}>{trans(item.name)}{/*this.props.lang*/}</Link>
                                    )}
                              </div>
                            </div>

                            <a href="#" className="logo-block w-nav-brand w--current">
                                <img src={"/static/images/header-logo.png"} className="logo" width="140.5" />
                            </a>
                            <nav role="navigation" className="nav-menu w-nav-menu">
                                <Link to={"/" + lang} style={{maxWidth: "940px"}} className="nav-link thin-light w-nav-link w--current">{trans('home')}</Link>
                                <Link to={code + "/pricing"} style={{maxWidth: "940px"}} className="nav-link thin-light w-nav-link">{trans('pricing')}</Link>
                                <Link to={code + "/templates"} style={{maxWidth: "940px"}} className="nav-link thin-light w-nav-link">{trans('Templates')}</Link>
                                <Link to={code + "/usecases"} style={{maxWidth: "940px"}} className="nav-link thin-light w-nav-link">{trans('use cases')}</Link>
                                <Link to={code + "/aboutus"} style={{maxWidth: "940px"}} className="nav-link thin-light w-nav-link">{trans('about us')}</Link>
                                <Link to={code + "/contact"} style={{maxWidth: "940px"}} className="nav-link thin-light w-nav-link active">{trans('contact')}</Link>
                                <a style={{maxWidth: "940px"}} target="_blank" href={process.env.REACT_APP_SERVER_URL} className="nav-link with-color-2 abitbrighter w-nav-link">{trans('open app')}</a>
                            </nav>
                            <div className="transparant-menu-button w-nav-button">
                                <div className="w-icon-nav-menu"></div>
                            </div>
                            <a target="_blank" href={process.env.REACT_APP_SERVER_URL} className="nav-link nav-link-mobile w-hidden-main w-hidden-tiny w-nav-link">{trans('Open App')}</a>
                        </div>
                        <div className="w-nav-overlay" data-wf-ignore=""></div>
                    </div>
                    <div className="container w-container">
                        <div style={{opacity: 1, display: "block", transition: "opacity 500ms ease 0s"}}
                            data-ix="fade-in-on-load-2" className="white-contact-form w-form">
                            <form id="wf-form-Email-Form-2" name="wf-form-Email-Form-1" data-name="Email Form 1">
                                <h1 className="form-title">{trans('Contact us now')}</h1>
                                <h2 className="form-title subtitle">
                                    {trans('Do you have a question? Contact us now')}
                                </h2>
                                <label htmlFor="name-2" className="field-label">{trans('Your name')}</label>
                                <input id="name-2" name="name" data-name="Name 2" maxLength="256" className="field rounded w-input" type="text" />
                                <label htmlFor="Email-3" className="field-label">{trans('Email address')}</label>
                                <input id="Email-3" name="Email" data-name="Email" maxLength="256" required="" className="field rounded w-input" type="email" />
                                <label htmlFor="Message" className="field-label">{trans('Your message')}</label>
                                <textarea id="Message" name="Message" maxLength="5000" data-name="Message" className="field rounded area w-input">
                                </textarea>
                                <input value={trans('Send Email')} data-wait="Please wait..." className="button w-button" type="submit" />
                            </form>
                            <div className="success-message w-form-done">
                                <p>
                                    {trans('Thank you Your submission has been received')}
                                </p>
                            </div>
                            <div className="error-bg w-form-fail">
                                <p>
                                    {trans('Oops Something went wrong while submitting the form')}
                                </p>
                            </div>
                        </div>
                        <div className="contact-info-block-right">
                            <div style={{opacity: 1, transition: "opacity 500ms ease 0s"}}
                                data-ix="fade-in-on-load-3" className="contact-info-block">
                                <div className="contact-info-small-block">
                                    <div className="small-contact-info-title">{trans('Enquiries and Demo request')}</div>
                                    <p className="contact-info-description">
                                        info@HansaBot.com
                                    </p>
                                </div>
                                <div className="contact-info-small-block">
                                    <div className="small-contact-info-title">{trans('Our Locations')}</div>
                                    <p className="contact-info-description">
                                        {trans('Our R and D teams are based in Melbourne, Australia and in Danang, Vietnam')}<br/><br/>{trans('We also have Sales Representatives at Singapore, Japan')}
                                    </p>
                                </div>
                                <div className="contact-info-small-block">
                                    <div className="small-contact-info-title">{trans('Support')}</div>
                                    <p className="contact-info-description">
                                        {trans('Premium Plans users can contact our Technical Support directly via in-app chats.')}<br /><br />{trans('Free Plan users can send emails to')} support@HansaBot.com {trans('for lower priority supports')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>














                <div className="section">
                    <div className="section-title-wrapper full-centered contact">
                        <h2 className="section-title">
                            {trans('Other ways to contact us')}
                        </h2>
                        <div className="div-block-2">
                        </div>
                    </div>
                    <div className="container w-container">
                        <div className="text-row w-row">
                            <div className="text-column w-clearfix w-col w-col-4">
                                <img src="/static/images/59fed69e519aa5000146763d_Icon-plane-blue.png" className="small-column-icon" />
                                <div className="text-column-title">{trans('pro Support desk')}</div>
                                <p className="small-paragraph">
                                    {trans('Our ticket-based support-desk for users and teams on PRO plan is coming soon. We will let you know once we release this powerful plan')}
                                </p>
                            </div>
                            <div className="text-column w-clearfix w-col w-col-4">
                                <img src="/static/images/59fed69e519aa5000146763d_Icon-plane-blue.png" className="small-column-icon" />
                                <div className="text-column-title">{trans('social networking')}</div>
                                <p className="small-paragraph">
                                    {trans('We rarely have enough time to respond to people on our social networking accounts. We leave it to the bots! Please seek other ways to contact us if speed matters')}
                                </p>
                            </div>
                            <div className="text-column w-col w-col-4">
                                <img src="/static/images/59fed69e519aa5000146763d_Icon-plane-blue.png" className="small-column-icon" width="16" />
                                <div className="text-column-title">{trans('in-app support chat')}</div>
                                <p className="small-paragraph">
                                    {trans('Our in-app chat helps connecting you directly with one of our developers. However as we are often busy improving the platform for you, it is not the most reliable way to contact us')}
                                </p>
                            </div>
                        </div>
                        <div className="top-line-block">
                            <div className="text-row w-row">
                                <div className="text-column w-clearfix w-col w-col-3">
                                    <img src="/static/images/5b373f51f68bd3f437f708e6_building.png" className="small-column-icon" />
                                    <div className="text-column-title">{trans('SINGAPORE')}</div>
                                    <p className="small-paragraph">
                                        {trans('HQ and Administration')}<br />info@HansaBot.com
                                    </p>
                                </div>
                                <div className="text-column w-clearfix w-col w-col-3">
                                    <img src="/static/images/5b373f51f68bd3f437f708e6_building.png" className="small-column-icon" />
                                    <div className="text-column-title">{trans('Danang, Vietnam')}</div>
                                    <p className="small-paragraph">
                                       {trans('R and D and Customer Support')}<br /> info@HansaBot.com<br />(+84)9-3541-7781
                                    </p>
                                </div>
                                <div className="text-column w-clearfix w-col w-col-3">
                                    <img src="/static/images/5b373f51f68bd3f437f708e6_building.png" className="small-column-icon" />
                                    <div className="text-column-title">{trans('Melbourne, australia')}</div>
                                    <p className="small-paragraph">
                                        {trans('R and D and Sales')}<br />info@HansaBot.com<br />(+61)4-3279-0855
                                    </p>
                                </div>
                                <div className="text-column w-clearfix w-col w-col-3">
                                    <img src="/static/images/5b373f51f68bd3f437f708e6_building.png" className="small-column-icon" />
                                    <div className="text-column-title">{trans('Tokyo, japan')}</div>
                                    <p className="small-paragraph">
                                        {trans('Regional Sales')}<br />info@HansaBot.com<br />(+81)80-5156-1901
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section tint">
                    <div className="container w-container">
                        <img src="/static/images/5a1417b0979ee200011c52b9_community.png" className="download-image-left" />
                        <div className="info-block-right download-info">
                            <div className="section-title-wrapper full info">
                                <div style={{opacity: 1, transform: "translateX(0px) translateY(0px) translateZ(0px)", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} data-ix="fade-in-on-scroll" className="small-section-title">{trans('the HansaBot community')}</div>
                                <h2 style={{opacity: 1, transform: "translateX(0px) translateY(0px) translateZ(0px)", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} data-ix="fade-in-on-scroll" className="section-title large">
                                    {trans('Help us building up a strong community')}
                                </h2>
                            </div>
                            <div style={{opacity: 1, transform: "translateX(0px) translateY(0px) translateZ(0px)", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} data-ix="fade-in-on-scroll" className="section-description">
                                {trans('This forum is free-to-access for everyone and we aim to build a healthy community where members can help each other out whether it is about technical issues or idea sharing')}
                                <br /><br />
                                {trans('Feel free to start asking around there, our staffs are also active in the forum as well')}
                            </div>
                            <a style={{opacity: 1, transform: "translateX(0px) translateY(0px) translateZ(0px)", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} href="#" data-ix="fade-in-on-scroll" target="_blank" className="button icon-button download w-button">
                                {trans('JoIn HansaBot community')}
                            </a>
                        </div>
                    </div>
                </div>
                <NewsLetter trans={trans} />
                <Footer trans={trans} />
            </div>
        )
    }

}

export default connect(state => ({

}), {

})(Contact);






// WEBPACK FOOTER //
// ./src/pages/Contact.js